import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { StateService } from '../services/state.service';
import { Router } from '@angular/router';

export const MaintenanceGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const stateService = inject(StateService);
  const router = inject(Router);

      stateService
      .getMaitenanceStatus()
      .subscribe({
        next: (data) => {
          if(data.maintenance){
            router.navigate(['/noavailable']);
            return false
          }else{
            return true
          } 
        },
        error: (error) => {return true}
      })
      
      return true
};
